export const PaymentMethod = {
  CREDIT_CARD: 'credit_card',
  BANK_SLIP: 'boleto',
  PIX: 'pix'
}

export const PaymentMethodTextForList = {
  credit_card: 'Cartão de Crédito',
  boleto: 'Boleto',
  pix: 'Pix'
}

export const BrandTabs = {
  ALL_VISION: 'all_vision',
  USERS: 'users'
}

export const CompanyCertificatesTabs = {
  PILLARS: 'pillars',
  USERS: 'users',
  FILES: 'files'
}

export const CertificateDetailsTabs = {
  CERTIFICATION_ITEM: 'certification_item',
  CERTIFICATION_FILES: 'certification_files',
  CERTIFICATION_PRICE: 'certification_price'
}

export const ConfigurationTabs = {
  TERMS_AND_CONDITIONS: 'terms_and_conditions',
  BANK_SLIP_CONFIG: 'bank_slip_config'
}
